import { useState } from "react";

import Alert from "ui-components/Alert";
import Modal from "ui-components/Modal";
import Divider from "ui-components/Divider";

import UploadFiles from "modules/data-files/elements/upload-files";
import { SelectMultipleData } from "modules/data-files/elements/Data-File-Select";

import Controls from "./Controls";
import SaveButton from "./Save";

const StackData = () => {
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<string[]>([]);

  return (
    <div className="mx-auto px-4 sm:px-6 mt-8">
      <Alert variant="info">
        <p className="pb-1">
          Selected files will be stacked on top of each other to create a new
          file. For example, you might have sales data, with one file per year,
          and you want to consolidate into a single file. Or you might have
          customer data, with one file per customer geography.
        </p>
        <p className="pb-1">
          You should ideally have SAME columns in all files. And all columns
          must have the SAME type, i.e., numeric everywhere, or date everywhere.
        </p>
        <p>
          However, that might not always be the case. Use the controls below to
          align files.
        </p>
      </Alert>
      {/* Data Selection */}
      <div id="select-data" className="mt-2 pt-2">
        <SelectMultipleData
          label={
            <div className="pr-2 mr-2">
              <p className="text-lg">Select Files to Stack:</p>
              <p className="font-normal text-sm text-gray-700">
                Cant find the data you want to select?{" "}
                <a
                  className="underline text-primary-main cursor-pointer"
                  onClick={() => setShowFileUpload(true)}
                >
                  Click here to upload.
                </a>
              </p>
            </div>
          }
          selected={selectedFiles}
          onChange={setSelectedFiles}
          help="These files will be stacked on top of each other. For example, if you File 1 has 10,000 rows, and File 2 has 20,000 rows, the resulting file shall have 30,000 rows."
        />
        <Modal
          show={showFileUpload}
          id="upload-files"
          handleClose={() => setShowFileUpload(false)}
        >
          <div className="m-2 p-2">
            <UploadFiles onComplete={() => setShowFileUpload(false)} />
          </div>
        </Modal>
      </div>
      {selectedFiles.length >= 1 && (
        <>
          <Divider />
          <Controls selectedFiles={selectedFiles} />
          <div className="pt-2 mt-1">
            <SaveButton fileIds={selectedFiles} />
          </div>
        </>
      )}
    </div>
  );
};

export default StackData;
